var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d4bc9dcb12feece49ea5bf8a1b77e77a8df3e1f8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["storefront@otovo"]={id:"d4bc9dcb12feece49ea5bf8a1b77e77a8df3e1f8"};
      